import core from './core';

const smoothScrolling = core.extend({
	constructor() {
		this.config = { el: '.scroll-to' };

		this.init();
	},

	init() {
		this.attachEvents();
	},

	attachEvents() {
		jQuery(document).on('click', this.config.el, this.scrollTo);
	},

	scrollTo(e) {
		e.preventDefault();
		e.stopPropagation();

		const className = jQuery(e.currentTarget).data('scroll');
		const target = jQuery(`.${className}`);

		if (!target.length) {
			return;
		}

		jQuery('html, body').stop().animate({ scrollTop: target.offset().top });
	},
});

export default smoothScrolling;
